import React, { useEffect, useState } from 'react';
import PopConfirm from '@omilia/popconfirm';
import styled from 'styled-components';
import { colors } from '@omilia/theme';

import Search from 'components/Search';
import InspectButton from 'components/InspectButton';

const SInspectHeader = styled.div`
  background-color: ${colors.COLOR_GREY_100};
  border-bottom: 1px solid ${colors.COLOR_GREY_400};
  display: flex;
  flex: 1;
  height: 40px;
  padding-right: 50px;
  position: relative;
`;

const SRight = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

const SLeft = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`;

const SSearchContainer = styled.div`
  margin: 2px;
`;

type Props = {
  dictionary: {
    id: string;
    archived: boolean;
  };
  itemsCount: number;
  selectedEntries: string[];
  onDelete: (id: string, selectedEntries: string[]) => void;
  onOpenUploadModal: () => void;
  onSearch: (searchTerm: string) => void;
  onSearchChange: (searchTerm: string) => void;
};

const DictionaryInspectHeaderContent = ({
  dictionary: { id, archived },
  itemsCount,
  selectedEntries,
  onDelete,
  onOpenUploadModal,
  onSearch,
  onSearchChange,
}: Props) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Call onSearchChange when component is un-mounted
  useEffect(() => () => onSearchChange(searchTerm), [
    onSearchChange,
    searchTerm,
  ]);

  const handleDelete = () => {
    onDelete(id, selectedEntries);
  };

  const handleSearch = (searchTerm: string) => {
    setSearchTerm(searchTerm);
    onSearch(searchTerm);
  };

  return (
    <SInspectHeader data-test="dictionary-inspect-header-content">
      <SLeft>
        <SSearchContainer>
          <Search key={id} getItems={handleSearch} itemsCount={itemsCount} />
        </SSearchContainer>
      </SLeft>
      <SRight>
        {!!selectedEntries.length && !archived && (
          <PopConfirm
            body={null}
            confirmLabel="Yes"
            declineLabel="Cancel"
            placement="left"
            title="Are you sure you want to delete the selected entries?"
            onConfirm={handleDelete}
            onDecline={() => null}
          >
            <InspectButton isHeader data-test="delete">
              Delete Selections
            </InspectButton>
          </PopConfirm>
        )}

        <InspectButton
          isHeader
          data-test="upload"
          disabled={archived}
          title="Upload a CSV file in order to add entries"
          onClick={onOpenUploadModal}
        >
          Upload CSV
        </InspectButton>
      </SRight>
    </SInspectHeader>
  );
};

export default DictionaryInspectHeaderContent;
